import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Spinner } from 'reactstrap';

const BreadCrumb = ({ title, links, setCurrent_Folder, isLoading }) => {
    document.title = "SPED - " + title;

    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">{title}</h4>

                        {links && links.length > 0 ? (
                            <div className="page-title-right">
                                {isLoading ? (
                                    <Spinner size='sm' className='me-2' />
                                ) : (
                                    <ol className="breadcrumb m-0">
                                        {links.slice(0, -1).map((link, index) => (
                                            <li className="breadcrumb-item" key={index}>
                                                <span onClick={() => setCurrent_Folder(link)} style={{ cursor: 'pointer', color: 'var(--vz-primary)' }}>{link.name}</span>
                                            </li>
                                        ))}
                                        <li className="breadcrumb-item active">{title}</li>
                                    </ol>
                                )}
                            </div>
                        ) : null}
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;
